module.exports = __webpack_public_path__ + "fonts/7fb4cb78-601f-4bb2-995a-442252089573.97b0d97.woff2";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/7fb4cb78-601f-4bb2-995a-442252089573.woff2
// module id = 307
// module chunks = 245 246